if (!customElements.get("custom-cursor")) {
  class CustomCursor extends HTMLElement {
    constructor() {
      super();

      // Check if device is touch-based (tablet or phone)
      if (this.isTouchDevice()) {
        return; // Don't initialize custom cursor on touch devices
      }

      this.cursor = this.querySelector(".custom-cursor");
      this.target = this.querySelector(".custom-cursor__target");

      if (!this.cursor || !this.target) {
        return;
      }

      this.toggleCursor();
      this.initCursor();
    }

    isTouchDevice() {
      const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      const hasHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

      // Disable on touch devices that don't have hover capability
      return hasTouch && !hasHover;
    }

    toggleCursor() {
      this.target.addEventListener(
        "mousemove",
        this.handleCursorMove.bind(this)
      );
      this.target.addEventListener("mouseover", this.initCursor.bind(this));
      this.target.addEventListener("mouseleave", this.removeCursor.bind(this));
    }

    initCursor(e) {
      this.cursor.classList.add("custom-cursor--active");
      this.cursor.style.left = `${e.clientX}px`;
      this.cursor.style.top = `${e.clientY}px`;
    }

    removeCursor() {
      this.cursor.classList.remove("custom-cursor--active");
    }

    handleCursorMove(e) {
      if(this.cursor.classList.contains("custom-cursor--initial-position")) {
        this.cursor.classList.remove("custom-cursor--initial-position");
      }

      this.cursor.style.left = `${e.clientX}px`;
      this.cursor.style.top = `${e.clientY}px`;
    }
  }
  customElements.define("custom-cursor", CustomCursor);
}
